import { forwardRef } from "react";
import { bool, string, node, arrayOf, oneOfType } from "prop-types";
import { Row } from "@tools";
import classnames from "classnames";

export const HeaderRow = forwardRef(({
  className,
  altBackground,
  ...props
}, ref) => (
  <Row
    ref={ref}
    {...props}
    isHeader
    noArrow
    altBackground={altBackground}
    className={classnames(
      "header preset-noedit",
      "z-100",
      className,
      altBackground ? "preset-page" : "preset-paper",
    )}
  />
));

HeaderRow.propTypes = {
  id: string,
  altBackground: bool,
  children: oneOfType([node, arrayOf(node)]).isRequired,
  className: string,
  // useExpandCell: bool,
  actionPresetClass: string,
};